// extracted by mini-css-extract-plugin
export default {"header":"_2nkv5fg76R3CyDjJrlb-Bl"};